module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("26tJd"))).then(() => module.bundle.root('dsisd'));